var map = {
	"./Tabela2.jpg": "1IBX",
	"./adenomiose.png": "Lx3F",
	"./flags/br.png": "3Iej",
	"./flags/de.png": "2Kt9",
	"./flags/es.png": "CtrT",
	"./flags/fr.png": "3cPx",
	"./flags/it.png": "8LUY",
	"./flags/ru.png": "B0tG",
	"./flags/us.png": "DERU",
	"./logo.png": "7Otq",
	"./logo_icon.png": "AQAX",
	"./miomas.png": "qclK",
	"./pe.png": "EjhR",
	"./quadrante_mama.png": "3daF",
	"./quadrante_mama_direita.png": "5iDR",
	"./quadrante_mama_esquerda.png": "V6pA",
	"./quadrante_mamario.png": "et7A",
	"./quadrante_mamas.png": "QI0Z"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 1